var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-contain cursor-pointer",on:{"click":_vm.gotoLink}},[_c('img',{staticClass:"icon-img",attrs:{"src":require("../assets/web/dashboard/icons/bells.png"),"alt":""}}),_c('span',{staticClass:"notification-bullet ml-1 p-1 bg-secondary"},[_vm._v(_vm._s(_vm.notification))])])
}
var staticRenderFns = []

export { render, staticRenderFns }